import {
  FileTextIcon,
  FileIcon,
  ImageIcon,
} from "lucide-react"
import { fileIcon } from "./helpers"

/** Returns the correct colored file icon for a given filename */
export function FileTypeIcon({ name }: { name: string }) {
  const type = fileIcon(name)
  if (type === "pdf")
    return <FileTextIcon className="size-4 shrink-0 text-red-500" />
  if (type === "image")
    return <ImageIcon className="size-4 shrink-0 text-blue-500" />
  return <FileIcon className="size-4 shrink-0 text-muted-foreground" />
}
